import { Navigate } from "react-router-dom";
import { getToken } from "../../../system/encryption";
import { globalConstants } from "../../../constants/index";

const PublicRoute = ({ children }) => {
    const token = getToken();
    const userToken = token || globalConstants.EMPTY_STRING;
    if (userToken && userToken.length > 0) {
      return <Navigate to="/blogs" />;
    } else {
     return children;
    }
};

export default PublicRoute;